module.exports = __webpack_public_path__ + "img/9788991931442.50efd229.jpg";